import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import * as AreasActions from './areas.actions';
import { Area, NonNullableGenericState, SelectorUtil } from '@us/web/shared/data-access';

export const AREAS_FEATURE_KEY = 'areas';

export type State = NonNullableGenericState<Area[]>;

export const initialState: State = {
    data: [],
    error: null,
    status: 'pending'
};

export const areasFeature = createFeature({
    name: AREAS_FEATURE_KEY,
    reducer: createReducer(
        initialState,
        on(AreasActions.init, (state): State => ({ ...state, status: 'loading', error: null })),
        on(
            AreasActions.loadAreasSuccess,
            (state, { areas }): State => ({
                ...state,
                data: areas,
                status: 'success'
            })
        ),
        on(AreasActions.loadAreasFailure, (state, { error }): State => ({ ...state, error }))
    )
});

export const { selectAreasState, selectData: selectAllAreas, selectStatus, selectError } = areasFeature;

export const selectAreasLoaded = createSelector(selectAreasState, SelectorUtil.isDone);

export const selectAllTables = createSelector(selectAllAreas, areas => areas.flatMap(area => area.tables));

export const selectTableById = (tableId: number) =>
    createSelector(selectAllTables, tables => tables.find(table => table.id === tableId));
